var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification01 = function SvgNotification01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#303A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M12.915 15a2.917 2.917 0 0 1-5.833 0M16.026 14.999H3.974a1.474 1.474 0 0 1-1.042-2.517l.502-.502a2.5 2.5 0 0 0 .733-1.768V7.915a5.833 5.833 0 0 1 11.666 0v2.297a2.5 2.5 0 0 0 .733 1.768l.502.502A1.474 1.474 0 0 1 16.026 15"
  })));
};
export default SvgNotification01;